"use strict";

var _createForOfIteratorHelper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _defineProperty = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var object_1 = require("./object");

var fieldTypes_1 = require("./constants/fieldTypes");

exports.submitListener = function (e, submitCallback) {
  if (e.key === 'Enter' && e.shiftKey === false) {
    e.preventDefault();
    submitCallback();
  }
};

exports.scrollToInvalid = function (errors) {
  if (errors) {
    var invalidInput = object_1.findKey(errors, function (key) {
      return key !== undefined;
    });

    if (document.getElementsByName(invalidInput)[0]) {
      window.scrollTo(0, window.pageYOffset + (document.getElementsByName(invalidInput)[0].getBoundingClientRect().top - 100));
    }
  }
};

exports.shouldShowErrors = function (meta) {
  return (!meta.active || meta.active && meta.submitFailed) && meta.invalid && meta.submitFailed;
};

exports.retrieveCreditCardValues = function (fieldValues, fields, fieldName) {
  var fieldNames = Object.keys(fieldValues);

  if (fieldName) {
    var newValues = Object.assign({}, fieldValues);
    delete newValues[fieldName];
    newValues = Object.assign(Object.assign({}, newValues), fieldValues[fieldName]);
    return newValues;
  }

  var findElement = function findElement(element, index) {
    return element.id.toString() === (fieldNames[index] && fieldNames[index].substring(2));
  };

  var index;

  for (var i = 0; i < fieldNames.length; i += 1) {
    var field = fields.find(findElement);

    if (field && field.type === fieldTypes_1.FIELD_ANIMATED_CREDIT_CARD) {
      index = i;
      break;
    }
  }

  if (index) {
    var _newValues = Object.assign({}, fieldValues);

    delete _newValues[fieldNames[index]];
    _newValues = Object.assign(Object.assign({}, _newValues), fieldValues[fieldNames[index]]);
    return _newValues;
  }

  return fieldValues;
};

exports.evaluateCaptcha = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fieldValues, fields, validateCaptchaService) {
    var fieldNames, findElement, index, i, field, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fieldNames = Object.keys(fieldValues);

            findElement = function findElement(element, index) {
              return element.id.toString() === (fieldNames[index] && fieldNames[index].substring(2));
            };

            i = 0;

          case 3:
            if (!(i < fieldNames.length)) {
              _context.next = 11;
              break;
            }

            field = fields.find(findElement);

            if (!(field && field.type === fieldTypes_1.FIELD_CAPTCHA)) {
              _context.next = 8;
              break;
            }

            index = i;
            return _context.abrupt("break", 11);

          case 8:
            i += 1;
            _context.next = 3;
            break;

          case 11:
            if (!index) {
              _context.next = 16;
              break;
            }

            _context.next = 14;
            return validateCaptchaService(fieldValues[fieldNames[index]]);

          case 14:
            response = _context.sent;
            return _context.abrupt("return", response.data.success);

          case 16:
            return _context.abrupt("return", true);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.removeAuxiliaryFields = function (fields) {
  return fields.filter(function (field) {
    return !field.auxiliary;
  });
};

exports.deleteValue = function (state, action) {
  var _a;

  if (action.type === '@@redux-form/REGISTER_FIELD') {
    if (!object_1.objectIsEmpty(state)) {
      var initialValue = (_a = state === null || state === void 0 ? void 0 : state.initial) === null || _a === void 0 ? void 0 : _a[action.payload.name];

      if (initialValue !== undefined && initialValue !== null) {
        var values = Object.assign(_defineProperty({}, action.payload.name, initialValue), state.values);
        return Object.assign(Object.assign({}, state), {
          values: values
        });
      }
    }
  }

  if (action.type === '@@redux-form/UNREGISTER_FIELD') {
    if (!object_1.objectIsEmpty(state) && state.values) {
      var _b = state,
          _c = _b.values,
          _d = action.payload.name,
          unregistered = _c[_d],
          _values = __rest(_c, [typeof _d === "symbol" ? _d : _d + ""]);

      return Object.assign(Object.assign({}, state), {
        values: _values
      });
    }
  }

  if (action.type === '@@redux-form/INITIALIZE') {
    if (!object_1.objectIsEmpty(state)) {
      return Object.assign(Object.assign({}, state), {
        values: {}
      });
    }
  }

  return state;
};

var uploadFile = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file, getUrlService, onFailure) {
    var urlRes, uploadedUrl;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getUrlService();

          case 2:
            urlRes = _context2.sent;

            if (!(urlRes.ok && urlRes.data)) {
              _context2.next = 9;
              break;
            }

            _context2.next = 6;
            return fetch(urlRes.data.url, {
              method: 'PUT',
              body: file,
              headers: {
                'Content-Type': file.type
              }
            });

          case 6:
            uploadedUrl = _context2.sent;

            if (!uploadedUrl.ok) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", urlRes.data.get_url ? urlRes.data.get_url : urlRes.data.url);

          case 9:
            if (onFailure) onFailure(urlRes.error);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function uploadFile(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

exports.uploadFiles = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(values, fields, getUrlService, onFailure) {
    var fieldsValues, newValues, fileFields, field, _iterator, _step, _loop, _ret;

    return _regeneratorRuntime.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            fieldsValues = Object.entries(values);
            newValues = Object.assign({}, values);
            fileFields = fieldsValues.filter(function (field) {
              return field[1] && field[1].file;
            });
            _iterator = _createForOfIteratorHelper(fileFields);
            _context4.prev = 4;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var fieldKey, originalField, url, childKeys, fieldType;
              return _regeneratorRuntime.wrap(function _loop$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      field = _step.value;
                      fieldKey = field[0].slice(2);
                      originalField = fields.find(function (_field) {
                        return _field.id.toString() === fieldKey;
                      });
                      _context3.next = 5;
                      return uploadFile(newValues[field[0]].file, getUrlService, onFailure);

                    case 5:
                      url = _context3.sent;

                      if (!url) {
                        _context3.next = 11;
                        break;
                      }

                      childKeys = originalField.configuration.child_keys;

                      if (childKeys && childKeys.url) {
                        fieldType = field[1].file.type;
                        newValues[field[0]] = Object.assign(Object.assign(_defineProperty({}, childKeys.url, url), childKeys.type && _defineProperty({}, childKeys.type, fieldType.substring(fieldType.indexOf('/') + 1))), childKeys.thumbnail_url && _defineProperty({}, childKeys.thumbnail_url, url));
                      } else {
                        newValues[field[0]] = url;
                      }

                      _context3.next = 12;
                      break;

                    case 11:
                      return _context3.abrupt("return", {
                        v: null
                      });

                    case 12:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _loop);
            });

            _iterator.s();

          case 7:
            if ((_step = _iterator.n()).done) {
              _context4.next = 14;
              break;
            }

            return _context4.delegateYield(_loop(), "t0", 9);

          case 9:
            _ret = _context4.t0;

            if (!(typeof _ret === "object")) {
              _context4.next = 12;
              break;
            }

            return _context4.abrupt("return", _ret.v);

          case 12:
            _context4.next = 7;
            break;

          case 14:
            _context4.next = 19;
            break;

          case 16:
            _context4.prev = 16;
            _context4.t1 = _context4["catch"](4);

            _iterator.e(_context4.t1);

          case 19:
            _context4.prev = 19;

            _iterator.f();

            return _context4.finish(19);

          case 22:
            return _context4.abrupt("return", newValues);

          case 23:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3, null, [[4, 16, 19, 22]]);
  }));

  return function (_x7, _x8, _x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

var FORM_UTILS = {
  submitListener: exports.submitListener,
  scrollToInvalid: exports.scrollToInvalid,
  shouldShowErrors: exports.shouldShowErrors,
  retrieveCreditCardValues: exports.retrieveCreditCardValues,
  evaluateCaptcha: exports.evaluateCaptcha,
  removeAuxiliaryFields: exports.removeAuxiliaryFields,
  deleteValue: exports.deleteValue,
  uploadFiles: exports.uploadFiles
};
exports.default = FORM_UTILS;